/**
 * @file SessionAnnotationsForm.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 13, 2023 16:39
 */
import PropTypes from 'prop-types';

import { arrayExists, objectExists } from 'src/@common/utilities';

import AnnotationsTableContainer from 'src/content/AnnotationsTable/AnnotationsTableContainer';
import SessionAnnotationsFormHeader from './SessionAnnotationsFormHeader.jsx';

function SessionAnnotationsForm(props) {
    const {
        annotations,
        pageNo,
        queryCount,
        metadata,
        pageCount,
        pageTitle,
        handleDeleteRows,
        handleCheckAllChange,
        handleCheckChange,
        handlePageNoChange,
    } = props;

    // const [contentSx, setContentSx] = useState();
    // const [tableSx, setTableSx] = useState();

    // useEffect(() => {
    //     if (pageCount > 0) {
    //         setContentSx({ height: '630px', width: '100%', mr: '5px', mb: '5px' });
    //         setTableSx({ height: '600px', width: '100%', mr: '5px', mb: '5px' });
    //     } else {
    //         setContentSx({ height: '0px', width: '100%', mr: '5px', mb: '5px', });
    //         setTableSx({
    //             height: '0px', width: '100%', mr: '5px', mb: '5px', mt: '0px',
    //         });
    //     }
    // }, [pageCount]);

    return (
        <>
            {objectExists(metadata) &&
                <SessionAnnotationsFormHeader
                    metadata={metadata}
                />
            }

            {arrayExists(annotations) &&
                <AnnotationsTableContainer
                    annotations={annotations}
                    currentPageNo={pageNo}
                    containerSx={{ width: '100%', ml: '0px', mb: '0px' }}

                    queryCount={queryCount}
                    pageCount={pageCount}

                    tableTitle={pageTitle}

                    deletable={true}
                    editable={true}
                    selectable={true}
                    viewable={true}

                    handleDeleteRows={handleDeleteRows}
                    handleCheckAllChange={handleCheckAllChange}
                    handleCheckChange={handleCheckChange}
                    handlePageNoChange={handlePageNoChange}
                />
            }
        </>
    )
}

SessionAnnotationsForm.propTypes = {
    annotations: PropTypes.array,
    pageNo: PropTypes.number.isRequired,
    queryCount: PropTypes.number.isRequired,
    metadata: PropTypes.object,
    pageCount: PropTypes.number,
    handleDeleteRows: PropTypes.func.isRequired,
    handleCheckAllChange: PropTypes.func.isRequired,
    handleCheckChange: PropTypes.func.isRequired,
    handlePageNoChange: PropTypes.func.isRequired,
    handleRefresh: PropTypes.func.isRequired,
};

export default SessionAnnotationsForm;
